/**
 * Admin / Supabase-auth account passwords (signup, invite, reset).
 * Strong enough for dashboards connected to billing (e.g. Stripe).
 */

export const ADMIN_PASSWORD_MIN_LENGTH = 12;
export const ADMIN_PASSWORD_MAX_LENGTH = 128;

export type AdminPasswordIssue =
  | 'TOO_SHORT'
  | 'TOO_LONG'
  | 'MISSING_LOWERCASE'
  | 'MISSING_UPPERCASE'
  | 'MISSING_DIGIT'
  | 'MISSING_SPECIAL';

/** Returns null if the password satisfies the policy. */
export function getAdminPasswordIssue(password: string): AdminPasswordIssue | null {
  if (password.length < ADMIN_PASSWORD_MIN_LENGTH) return 'TOO_SHORT';
  if (password.length > ADMIN_PASSWORD_MAX_LENGTH) return 'TOO_LONG';
  if (!/[a-z]/.test(password)) return 'MISSING_LOWERCASE';
  if (!/[A-Z]/.test(password)) return 'MISSING_UPPERCASE';
  if (!/\d/.test(password)) return 'MISSING_DIGIT';
  if (!/[^A-Za-z0-9]/.test(password)) return 'MISSING_SPECIAL';
  return null;
}
